import ScrollMagic from 'scrollmagic';
import "../scss/page.scss";

import "../scss/home.scss";

import "jquery-match-height";

import "./scripts/typewriter.js";
import "./scripts/ebook.js";
import "./scripts/calculatepadding.js";
import "./scripts/animatenumber.js";
import "./scripts/market.js";
import "./scripts/home.js";
import "./scripts/slick-carousel.js";
import "./scripts/slick/home-stats.js";
import "./scripts/slick/home-hero.js";
import "./scripts/slick/home-projects.js";
import "./scripts/scroll-magic/markets-home.js";
import "./scripts/matchHeight/home.js";
import "./scripts/home-seo.js";
import "./scripts/careers/faq.js";
import "./scripts/markets-new.js";
